var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    className: "icon",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m621.093 219.292 204.495-118.227a78.7 78.7 0 0 1 86.172 1.22c46.014 29.615 96.642 55.987 96.642 55.987L763.27 302.795zM618.9 506.794l142.903-81.558 246.847 142.655-112.221 66.455s-30.682 22.158-93.724-19.069S618.9 506.794 618.9 506.794M435.476 613.122l77.42-43.82 76.676 44.926-19.355 376.82-58.064 32.513-57.684-33.599zM13.425 158.501 368.85 363.472s52.077 23.016 78.888 53.145c24.961 28.05-11.69 75.017-11.69 75.017l219.064-129.668L186.761 91.302s-34.095-16.933-85.696 14.607-87.64 52.592-87.64 52.592"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.446 568.253 115.958 65.502a6.5 6.5 0 0 0 .896.439c4.481 1.906 38.977 15.16 79.822-14.34 41.8-30.186 207.623-119.276 222.84-127.438a9.4 9.4 0 0 0 2.154-1.582c6.808-6.732 45.575-49.046-2.67-88.404-.571-.458-3.05-2.822-3.813-2.917l-21.357-14.111-14.664-8.963-20.976-10.984c-2.917-1.62-6.483.306-9.382 1.907zM647.103 84.59 507.976 1.697 369.231 84.952l139.108 81.806z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ae2768a7e83ae0e7c5ab95e7c0fe43c4.svg";
export { ForwardRef as ReactComponent };